<template>
	<div>
		<div class="row-fluid">
			<!--最新活动-->
			<div class="span12 text-left">
				<div style="padding-bottom: 10px">
					<img style="width: 100%" :src="models.imgages_b" />
				</div>

				<div>
					<h4>{{ models.title }}</h4>
					<div class="row">
						<div class="col-12" style="text-indent: 2em; font-size: 15px; line-height: 35px">
							<samp v-html="models.detailed"></samp>
						</div>
					</div>
				</div>
			</div>
			<div style="height: 30px"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				models: {},
			};
		},
		methods: {
			sel(id) {
				this.$api
					.getAPI("data/info/" + id + "?type_id=20201112&state=1", {})
					.then((res) => {
						console.log(res.data.data.models);
						this.models = res.data.data.models;
					});
			},
		},
		mounted() {
			var id = this.$route.query.id;
			this.sel(id);
		},
	};
</script>

<style scoped>
	.input-group input {
		border: 1px solid #ccc;
		padding-left: 12px;
	}

	.label-primary {
		color: #3480fa;
		background-color: #dcdfe6;
	}

	.label_50 {
		border-radius: 50px/50px;
	}

	.i2 {
		position: absolute;
		right: 30px;
		top: 106px;
		font-size: 25px !important;
	}

	.ic2 {
		position: absolute;
		right: 30px;
		top: 112px;
		font-size: 18px !important;
		color: #ffd986;
	}

	.i3 {
		position: absolute;
		right: 25px;
		top: 56px;
		font-size: 25px !important;
	}

	.ic3 {
		position: absolute;
		right: 25px;
		top: 60px;
		font-size: 18px !important;
		color: #ffd986;
	}

	.pop {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
	}

	.container-fluid-a {
		position: absolute;
		top: 50px;
	}

	.is {
		width: 50px;
		text-align: center;
		line-height: 25px;
		height: 50px;
		font-size: 14px;
		border: 1px solid #c0c0c0;
	}

	.jumbotron {
		margin-bottom: 20px;
		border-radius: 0rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/web/bwg/show_info_c.vue